import Vue from 'vue';
import Router from 'vue-router';
import * as ROUTES from '@/constants/routes.js';
import * as GETTERS from '@/store/constants/getters.js';
import * as ACTIONS from '@/store/constants/actions.js';
Vue.use(Router);

export const initializeRouter = (vuexStore) => {
    const router = new Router({
        mode: 'history',
        base: process.env.BASE_URL,
        routes: [
            {
                path: '/',
                redirect: '/moderation',
            },
            {
                path: '/moderation',
                name: ROUTES.MODERATION,
                redirect: '/moderation/workspaces',
                component: () => import(/* webpackChunkName: "moderation" */ './views/Moderation.vue'),
                children: [
                    {
                        path: '/moderation/workspaces',
                        name: ROUTES.WORKSPACES,
                        component: () => import(/* webpackChunkName: "workspaces" */ './views/Workspaces.vue'),
                    },
                    {
                        path: '/moderation/quick_search',
                        name: ROUTES.QUICK_SEARCH,
                        component: () => import(/* webpackChunkName: "quickSearch" */ './views/QuickSearch.vue'),
                    },
                    {
                        path: '/moderation/:workspace_uuid',
                        name: ROUTES.WORKSPACE,
                        // route level code-splitting
                        // this generates a separate chunk (workspace.[hash].js) for this route
                        // which is lazy-loaded when the route is visited.
                        component: () => import(/* webpackChunkName: "workspace" */ './views/Workspace.vue'),
                        children: [
                            {
                                path: 'new_workspace',
                                name: ROUTES.NEW_WORKSPACE,
                                component: () => import(/* webpackChunkName: "blankWorkspace" */ './views/subviews/BlankWorkspace.vue'),
                            }, {
                                path: 'queue/create',
                                name: ROUTES.CREATE_QUEUE,
                                component: () => import(/* webpackChunkName: "create-queue" */ './views/subviews/CreateQueue.vue'),
                            },
                            {
                                path: 'new_queue',
                                name: ROUTES.NEW_QUEUE,
                                component: () => import(/* webpackChunkName: "new_queue" */ './views/subviews/NewQueue.vue'),
                            },
                            {
                                path: 'new_search',
                                name: ROUTES.NEW_SEARCH,
                                component: () => import(/* webpackChunkName: "new_search" */ './views/subviews/NewSearch.vue'),
                            },
                            {
                                path: 'queue/:queue_uuid',
                                name: ROUTES.QUEUE,
                                component: () => import(/* webpackChunkName: "queue" */ './views/subviews/Queue.vue'),
                            },
                            {
                                path: 'search/:saved_search_uuid',
                                name: ROUTES.SEARCH,
                                component: () => import(/* webpackChunkName: "search" */ './views/subviews/Search.vue'),
                            },
                        ],
                    },
                ],
            },
            {
                path: '*',
                name: ROUTES.NOT_FOUND,
                component: () => import(/* webpackChunkName: "404" */ './views/404.vue'),
            },
        ],
    });

    router.beforeEach(function(to, from, next) {
        // We want to send the current attention time on any route change
        vuexStore.dispatch(ACTIONS.SEND_ATTENTION_TIME, {});

        // If the console is out of date, then we want to do a regular browser page redirect
        // so that the JS will get reloaded and the user will be up to date
        if (vuexStore.getters[GETTERS.IS_OUT_OF_DATE]) {
            window.location.href = to.path;
        }
        else {
            next();
        }
    });

    return router;
};
